import { render, staticRenderFns } from "./FilesPicker.vue?vue&type=template&id=5720fc76&scoped=true"
import script from "./FilesPicker.vue?vue&type=script&lang=js"
export * from "./FilesPicker.vue?vue&type=script&lang=js"
import style0 from "./FilesPicker.vue?vue&type=style&index=0&id=5720fc76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5720fc76",
  null
  
)

export default component.exports